import type { UninvitedUserVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveUninvitedUsers = createApiThunk<UninvitedUserVM[], void>(
  "users/retrieveUninvitedUsers",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listUninvitedUsers();
  },
);
